/*
 * Divara personalisation: required name + birthstone on the product page,
 * and in-cart editing of both.
 */
(function () {
  if (window.__dvPersonalise) return;
  window.__dvPersonalise = true;

  /* ---------- Product page ---------- */

  function formFor(field) {
    return document.getElementById(field.dataset.formId);
  }

  function showError(field, show) {
    var err = field.querySelector('[data-dv-error]');
    if (err) {
      if (!err.dataset.default) err.dataset.default = err.textContent;
      var input = field.dataset.dvRequired === 'name' && field.querySelector('input[type="text"]');
      var tooLong = input && input.maxLength > 0 && input.value.trim().length > input.maxLength;
      err.textContent = tooLong ? 'Up to ' + input.maxLength + ' characters. Please check your spelling.' : err.dataset.default;
      err.hidden = !show;
    }
    field.classList.toggle('dv-field--invalid', show);
  }

  function isFieldValid(field) {
    if (field.dataset.dvRequired === 'name') {
      var input = field.querySelector('input[type="text"]');
      if (!input) return false;
      var value = input.value.trim();
      return value.length > 0 && value.length <= (input.maxLength > 0 ? input.maxLength : 12);
    }
    if (field.dataset.dvRequired === 'birthstone') {
      return !!field.querySelector('input[data-month]:checked');
    }
    return true;
  }

  // Returns the first invalid field for the given form id (or null when valid).
  function validate(formId) {
    var fields = document.querySelectorAll('[data-dv-required][data-form-id="' + formId + '"]');
    var firstInvalid = null;
    fields.forEach(function (field) {
      var ok = isFieldValid(field);
      showError(field, !ok);
      if (!ok && !firstInvalid) firstInvalid = field;
    });
    return firstInvalid;
  }

  function setVariant(field, variantId) {
    var form = formFor(field);
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) {
      idInput.value = variantId;
      idInput.disabled = false;
    }
  }

  // Resolve the variant for the chosen Colour + Birthstone using the JSON map in the field.
  function variantMap(root) {
    if (root.__dvMap) return root.__dvMap;
    var el = root.querySelector('[data-dv-variant-map]');
    try { root.__dvMap = el ? JSON.parse(el.textContent) : {}; } catch (e) { root.__dvMap = {}; }
    return root.__dvMap;
  }

  function resolveVariant(root, colour, month) {
    var map = variantMap(root);
    var hit = map[(colour ? colour + '|' : '') + month] || map[month];
    return hit && hit.available !== false ? hit.id : null;
  }

  function syncBirthstone(field) {
    var colourInput = field.querySelector('input[data-colour]:checked');
    var monthInput = field.querySelector('input[data-month]:checked');
    var colour = colourInput ? colourInput.value : '';
    var colourLabel = field.querySelector('[data-dv-colour-label]');
    if (colourLabel && colour) colourLabel.textContent = colour;
    if (colourInput && colourInput.dataset.material) {
      document.querySelectorAll('[data-dv-material], .product__info-container .icon-with-text li:first-child .h4').forEach(function (el) {
        el.textContent = colourInput.dataset.material;
      });
    }
    var label = field.querySelector('[data-dv-selected-label]');
    if (monthInput && label) label.textContent = monthInput.value + ' selected';
    if (!monthInput) return;
    var id = resolveVariant(field, colour, monthInput.value);
    if (id) setVariant(field, id);
  }

  function initBirthstone(field) {
    if (field.__dvInit) return;
    field.__dvInit = true;
    syncBirthstone(field);
    field.addEventListener('change', function (e) {
      if (e.target.type !== 'radio') return;
      syncBirthstone(field);
      if (e.target.dataset.month) showError(field, false);
    });
  }

  function initName(field) {
    if (field.__dvInit) return;
    field.__dvInit = true;
    var input = field.querySelector('input[type="text"]');
    var count = field.querySelector('[data-dv-count]');
    var update = function () {
      if (count) count.textContent = input.value.length + '/' + input.maxLength;
      if (input.value.trim()) showError(field, false);
    };
    input.addEventListener('input', update);
    update();
  }

  function initProductFields() {
    document.querySelectorAll('[data-dv-required="birthstone"]').forEach(initBirthstone);
    document.querySelectorAll('[data-dv-required="name"], [data-dv-optional="name"]').forEach(initName);
  }

  function blockIfInvalid(e, formId) {
    if (!formId || !document.querySelector('[data-dv-required][data-form-id="' + formId + '"]')) return;
    var invalid = validate(formId);
    if (!invalid) {
      prepareSubmit(formId);
      var second = pairSecond(formId);
      if (second) {
        e.preventDefault();
        e.stopImmediatePropagation();
        submitPair(formId, second, e.target.closest ? e.target.closest('button') : null);
      }
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    var y = invalid.getBoundingClientRect().top + window.scrollY - window.innerHeight / 3;
    window.scrollTo({ top: Math.max(y, 0), behavior: 'smooth' });
    var focusable = invalid.querySelector('input[type="text"], input[type="radio"]:not(:disabled)');
    if (focusable) focusable.focus({ preventScroll: true });
  }

  // Right before a valid add-to-cart: strip outer spaces from the name (spelling and
  // capitalisation are kept as typed) and re-sync the variant with the checked swatch.
  function prepareSubmit(formId) {
    document.querySelectorAll('[data-dv-required][data-form-id="' + formId + '"], [data-dv-optional][data-form-id="' + formId + '"]').forEach(function (field) {
      if (field.dataset.dvRequired === 'name' || field.dataset.dvOptional === 'name') {
        var input = field.querySelector('input[type="text"]');
        if (input && input.value !== input.value.trim()) {
          input.value = input.value.trim();
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
      } else if (field.dataset.dvRequired === 'birthstone') {
        syncBirthstone(field);
      }
    });
  }

  // Capture phase so we run before the theme's own add-to-cart handlers
  // (covers the main button and the sticky ATC button, which targets the same form).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button');
    if (!btn) return;
    var form = btn.form || (btn.getAttribute('form') && document.getElementById(btn.getAttribute('form')));
    if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (btn.type !== 'submit' && !btn.classList.contains('main-product-atc')) return;
    blockIfInvalid(e, form.getAttribute('id')); // not form.id: the form has an input named "id"
  }, true);

  // Enter key inside the form, or any other programmatic submit.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    blockIfInvalid(e, form.getAttribute('id')); // not form.id: the form has an input named "id"
  }, true);

  /* ---------- Product page: extra name fields follow the chosen bundle size ---------- */

  function bundleQty(formId) {
    var form = document.getElementById(formId);
    var input = (form && form.querySelector('input[name="quantity"]')) || document.querySelector('product-form input[name="quantity"], input[name="quantity"]');
    var q = parseInt(input && input.value, 10);
    return isNaN(q) ? 1 : q;
  }

  function syncQtyFields() {
    document.querySelectorAll('[data-dv-min-qty]').forEach(function (field) {
      var input = field.querySelector('input[type="text"]');
      var show = bundleQty(field.dataset.formId) >= parseInt(field.dataset.dvMinQty, 10);
      if (show === !field.hidden) return;
      field.hidden = !show;
      if (!input) return;
      input.disabled = !show;
      input.required = show;
      if (show) {
        field.dataset.dvRequired = 'name';
        delete field.dataset.dvOptional;
      } else {
        delete field.dataset.dvRequired;
        field.dataset.dvOptional = 'name';
        input.value = '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        showError(field, false);
      }
    });
  }

  var qtyQueued = false;
  function queueQtySync() {
    if (qtyQueued) return;
    qtyQueued = true;
    requestAnimationFrame(function () { qtyQueued = false; syncQtyFields(); });
  }
  if (document.querySelector('[data-dv-min-qty]') || document.readyState === 'loading') {
    new MutationObserver(queueQtySync).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['class'] });
    document.addEventListener('click', function () { setTimeout(syncQtyFields, 50); }, true);
    document.addEventListener('change', function () { setTimeout(syncQtyFields, 50); }, true);
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-dv-min-qty] input[type="text"]').forEach(function (i) { i.disabled = true; });
    syncQtyFields();
    setTimeout(syncQtyFields, 1500);
  });

  /* ---------- Sticky add-to-cart mirrors the current selection ---------- */

  function updateSticky() {
    var sticky = document.querySelector('sticky-atc');
    var field = document.querySelector('[data-dv-required="birthstone"]');
    if (!sticky) return;
    var formId = (field && field.dataset.formId) || (document.querySelector('.dv-name') || {}).dataset && document.querySelector('.dv-name').dataset.formId;
    var parts = [];
    var pair = formId && pairSecond(formId);
    if (pair) parts.push('2 necklaces');
    if (field) {
      var colour = field.querySelector('input[data-colour]:checked');
      if (colour) parts.push(colour.value);
      var stones = document.querySelectorAll('[data-dv-required="birthstone"][data-form-id="' + field.dataset.formId + '"]');
      var picked = [];
      stones.forEach(function (f) {
        var m = f.querySelector('input[data-month]:checked');
        if (m) picked.push(m.value);
      });
      if (picked.length === stones.length) parts.push(picked.join(' & '));
      else parts.push(stones.length > 1 ? 'Choose your birthstones' : 'Choose your birthstone');
    }
    var summary = sticky.querySelector('.dv-sticky-summary');
    var title = sticky.querySelector('.sticky-atc__title');
    if (!summary && title && parts.length) {
      summary = document.createElement('p');
      summary.className = 'dv-sticky-summary';
      title.insertAdjacentElement('afterend', summary);
    }
    if (summary) summary.textContent = parts.join(' · ');
    var price = sticky.querySelector('.sticky-atc__price');
    if (price) {
      if (!price.dataset.dvOriginal) price.dataset.dvOriginal = price.innerHTML;
      var pairPrice = document.querySelector('.dv-pair-option--featured .dv-pair-option__now');
      if (pair && pairPrice) {
        price.innerHTML = '<span class="dv-sticky-price">' + pairPrice.textContent.trim() + '</span>';
      } else {
        price.innerHTML = price.dataset.dvOriginal;
      }
    }
  }
  document.addEventListener('change', function () { setTimeout(updateSticky, 0); });
  document.addEventListener('DOMContentLoaded', updateSticky);

  /* ---------- Product page: add 2 necklaces at once ---------- */

  // Returns the visible second-necklace block for this form when "2 necklaces" is chosen.
  function pairSecond(formId) {
    var choice = document.querySelector('[data-dv-pair-choice][data-form-id="' + formId + '"] input:checked');
    if (!choice || choice.value !== '2') return null;
    return document.querySelector('[data-dv-pair-second][data-form-id="' + formId + '"]');
  }

  function pairError(box, msg, focusEl) {
    var err = box.querySelector('[data-dv-pair-error]');
    err.textContent = msg;
    err.hidden = !msg;
    box.classList.toggle('dv-field--invalid', !!msg);
    if (msg && focusEl) {
      var y = box.getBoundingClientRect().top + window.scrollY - window.innerHeight / 3;
      window.scrollTo({ top: Math.max(y, 0), behavior: 'smooth' });
      focusEl.focus({ preventScroll: true });
    }
  }

  function submitPair(formId, box, btn) {
    var form = document.getElementById(formId);
    var nameInput = box.querySelector('[data-dv-pair-name]');
    var monthSel = box.querySelector('[data-dv-month-select]');
    nameInput.value = nameInput.value.trim();
    if (!nameInput.value) return pairError(box, 'Please enter a name for your second necklace.', nameInput);
    syncCartVariant(box);
    var secondId = box.querySelector('[data-dv-pair-variant]').value;
    if (!monthSel.value || !secondId) return pairError(box, 'Please choose a birthstone for your second necklace.', monthSel);
    pairError(box, '');
    var firstName = document.querySelector('.dv-name[data-form-id="' + formId + '"] input[type="text"]');
    var firstId = form.querySelector('input[name="id"]').value;
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    postJSON('/cart/add.js', {
      items: [
        { id: parseInt(firstId, 10), quantity: 1, properties: { 'Your Name': firstName ? firstName.value.trim() : '' } },
        { id: parseInt(secondId, 10), quantity: 1, properties: { 'Your Name': nameInput.value } }
      ],
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    })
      .then(function (res) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && res.sections && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id: firstId, sections: res.sections });
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) { pairError(box, err.message || 'Could not add to cart. Please try again.'); })
      .finally(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); } });
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-dv-pair-qty]')) return;
    var formId = e.target.closest('[data-dv-pair-choice]').dataset.formId;
    var box = document.querySelector('[data-dv-pair-second][data-form-id="' + formId + '"]');
    if (box) box.hidden = e.target.value !== '2';
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-dv-pair-name]')) return;
    var box = e.target.closest('[data-dv-pair-second]');
    var count = box.querySelector('[data-dv-pair-count]');
    if (count) count.textContent = e.target.value.length + '/' + e.target.maxLength;
    if (e.target.value.trim()) pairError(box, '');
  });

  /* ---------- Cart: edit personalisation ---------- */

  function refreshCart() {
    if (document.querySelector('cart-items:not(cart-drawer-items), #main-cart-items')) {
      window.location.reload();
      return Promise.resolve();
    }
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parse = function (html) { return new DOMParser().parseFromString(html, 'text/html'); };
        if (sections['cart-drawer']) {
          var target = document.querySelector('#CartDrawer .drawer__inner');
          var source = parse(sections['cart-drawer']).querySelector('#CartDrawer .drawer__inner');
          if (target && source) target.innerHTML = source.innerHTML;
        }
        if (sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          var bubbleSrc = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
          if (bubble && bubbleSrc) bubble.innerHTML = bubbleSrc.innerHTML;
        }
      });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Could not update the cart.');
        return data;
      });
    });
  }

  function saveEdit(box) {
    var err = box.querySelector('[data-dv-edit-error]');
    var nameInput = box.querySelector('[data-dv-edit-name]');
    syncCartVariant(box);
    var variantSelect = box.querySelector('[data-dv-edit-variant]');
    var saveBtn = box.querySelector('[data-dv-edit-save]');
    var key = box.dataset.key;
    err.hidden = true;

    if (nameInput) nameInput.value = nameInput.value.trim();
    if (nameInput && !nameInput.value) {
      err.textContent = 'Please enter a name before adding to cart.';
      err.hidden = false;
      nameInput.focus();
      return;
    }

    saveBtn.disabled = true;
    saveBtn.textContent = 'Saving…';

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = cart.items.find(function (i) { return i.key === key; });
        if (!item) throw new Error('This item is no longer in your cart.');

        var props = Object.assign({}, item.properties || {});
        if (nameInput) props['Your Name'] = nameInput.value.trim();
        var name2Input = box.querySelector('[data-dv-edit-name2]');
        if (name2Input) {
          if (name2Input.value.trim()) props['Second Name'] = name2Input.value.trim();
          else delete props['Second Name'];
        }
        var newVariant = variantSelect ? parseInt(variantSelect.value, 10) : item.variant_id;

        if (newVariant === item.variant_id) {
          return postJSON('/cart/change.js', { id: key, quantity: item.quantity, properties: props });
        }
        // Different birthstone = different variant: add the new line, then remove the old one.
        return postJSON('/cart/add.js', {
          items: [{ id: newVariant, quantity: item.quantity, properties: props }]
        }).then(function () {
          // Line keys change when the cart changes (discount allocations), so find the
          // original line again by its variant + personalisation before removing it.
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (fresh) {
              var same = function (i) {
                return i.variant_id === item.variant_id &&
                  JSON.stringify(i.properties || {}) === JSON.stringify(item.properties || {});
              };
              var old = fresh.items.find(same);
              if (!old) return null;
              return postJSON('/cart/change.js', { id: old.key, quantity: 0 });
            });
        });
      })
      .then(refreshCart)
      .catch(function (e) {
        err.textContent = e.message;
        err.hidden = false;
        saveBtn.disabled = false;
        saveBtn.textContent = 'Save';
      });
  }

  /* ---------- Order export: personalisation as a cart (note) attribute ----------
   * Shopify's order CSV export has no line-item property columns, but it does export
   * "Note Attributes". Before checkout we write every personalised line into the
   * "Personalisation" cart attribute so the supplier sees names in the export.
   */

  function personalisationSummary(cart) {
    return cart.items
      .map(function (i) {
        var props = Object.keys(i.properties || {})
          .filter(function (k) { return k.charAt(0) !== '_' && i.properties[k]; })
          .map(function (k) { return (k === 'Your Name' ? 'Name' : k) + ': ' + i.properties[k]; });
        if (!props.length) return '';
        return i.quantity + 'x ' + i.product_title.replace(/\.$/, '') +
          (i.variant_title ? ' (' + i.variant_title + ')' : '') + ' — ' + props.join(', ');
      })
      .filter(Boolean)
      .join('\n');
  }

  function syncPersonalisation() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var summary = personalisationSummary(cart);
        var current = (cart.attributes && cart.attributes.Personalisation) || '';
        if (summary === current) return;
        return postJSON('/cart/update.js', { attributes: { Personalisation: summary } });
      });
  }
  window.dvSyncPersonalisation = syncPersonalisation;

  // Any checkout button (drawer or cart page): sync first, then continue as normal.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"]');
    if (!btn || btn.dataset.dvSynced === '1') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var resume = function () {
      btn.dataset.dvSynced = '1';
      btn.click();
      setTimeout(function () { btn.dataset.dvSynced = ''; }, 3000);
    };
    syncPersonalisation().then(resume, resume);
  }, true);

  /* ---------- Cart: Colour + Birthstone selects resolve to one variant ---------- */

  function syncCartVariant(box) {
    var monthSel = box.querySelector('[data-dv-month-select]');
    if (!monthSel) return;
    var colourSel = box.querySelector('[data-dv-colour-select]');
    var target = box.querySelector('[data-dv-edit-variant], [data-dv-upsell-variant], [data-dv-pair-variant]');
    var id = monthSel.value ? resolveVariant(box, colourSel ? colourSel.value : '', monthSel.value) : null;
    if (target) target.value = id || '';
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-dv-month-select], [data-dv-colour-select]')) return;
    var box = e.target.closest('[data-dv-cart-edit], [data-dv-upsell], [data-dv-pair-second]');
    if (box) syncCartVariant(box);
  });

  /* ---------- Cart: shipping protection toggle ---------- */

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-dv-protection]');
    if (!input) return;
    var label = input.closest('.dv-protection');
    input.disabled = true;
    var req = input.checked
      ? postJSON('/cart/add.js', { items: [{ id: parseInt(input.dataset.variantId, 10), quantity: 1 }] })
      : fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var line = cart.items.find(function (i) { return String(i.variant_id) === String(input.dataset.variantId); });
            return line ? postJSON('/cart/change.js', { id: line.key, quantity: 0 }) : null;
          });
    if (label) label.classList.toggle('is-on', input.checked);
    req.then(refreshCart).catch(function () {
      input.checked = !input.checked;
      input.disabled = false;
      if (label) label.classList.toggle('is-on', input.checked);
    });
  });

  // Protection left on its own (everything else removed): take it out too.
  function removeOrphanProtection() {
    var orphan = document.querySelector('[data-dv-orphan-protection]');
    if (!orphan || orphan.dataset.dvBusy) return;
    orphan.dataset.dvBusy = '1';
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = cart.items.find(function (i) { return i.handle === 'shipping-protection'; });
        return line ? postJSON('/cart/change.js', { id: line.key, quantity: 0 }) : null;
      })
      .then(refreshCart, function () {});
  }
  new MutationObserver(removeOrphanProtection).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', removeOrphanProtection);

  /* ---------- Cart: add another of the product in the cart (2nd/3rd piece 25% off) ---------- */

  function addUpsell(box) {
    var nameInput = box.querySelector('[data-dv-upsell-name]');
    syncCartVariant(box);
    var select = box.querySelector('[data-dv-upsell-variant]');
    var monthSel = box.querySelector('[data-dv-month-select]');
    var err = box.querySelector('[data-dv-upsell-error]');
    var btn = box.querySelector('[data-dv-upsell-add]');
    var name = nameInput.value.trim();
    err.hidden = true;
    if (!name) {
      err.textContent = 'Please enter a name before adding to cart.';
      err.hidden = false;
      nameInput.focus();
      return;
    }
    if (!select.value) {
      err.textContent = 'Please choose your birthstone.';
      err.hidden = false;
      (monthSel || select).focus();
      return;
    }
    // Birthstones saved as line properties (single-variant products, 2nd/3rd stones)
    var properties = { 'Your Name': name };
    var props = box.querySelectorAll('[data-dv-upsell-prop]');
    for (var i = 0; i < props.length; i++) {
      if (!props[i].value) {
        err.textContent = 'Please choose ' + (props.length > 1 ? 'each birthstone.' : 'your birthstone.');
        err.hidden = false;
        props[i].focus();
        return;
      }
      properties[props[i].dataset.dvUpsellProp] = props[i].value;
    }
    btn.disabled = true;
    btn.textContent = 'Adding…';
    postJSON('/cart/add.js', {
      items: [{ id: parseInt(select.value, 10), quantity: 1, properties: properties }]
    })
      .then(refreshCart)
      .catch(function (e) {
        err.textContent = e.message;
        err.hidden = false;
        btn.disabled = false;
        btn.textContent = btn.dataset.label || 'Add necklace';
      });
  }

  document.addEventListener('click', function (e) {
    var upsell = e.target.closest('[data-dv-upsell-add]');
    if (upsell) {
      e.preventDefault();
      addUpsell(upsell.closest('[data-dv-upsell]'));
      return;
    }
    var save = e.target.closest('[data-dv-edit-save]');
    if (save) {
      e.preventDefault();
      saveEdit(save.closest('[data-dv-cart-edit]'));
      return;
    }
    var cancel = e.target.closest('[data-dv-edit-cancel]');
    if (cancel) {
      e.preventDefault();
      var box = cancel.closest('[data-dv-cart-edit]');
      box.querySelectorAll('input, select').forEach(function (el) {
        if (el.tagName === 'SELECT') {
          Array.prototype.forEach.call(el.options, function (o) { o.selected = o.defaultSelected; });
        } else {
          el.value = el.defaultValue;
        }
      });
      box.querySelector('[data-dv-edit-error]').hidden = true;
      box.open = false;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-dv-upsell-name]')) {
      e.preventDefault();
      addUpsell(e.target.closest('[data-dv-upsell]'));
      return;
    }
    if (e.key === 'Enter' && e.target.matches('[data-dv-edit-name]')) {
      e.preventDefault();
      saveEdit(e.target.closest('[data-dv-cart-edit]'));
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductFields);
  } else {
    initProductFields();
  }
  document.addEventListener('shopify:section:load', initProductFields);
})();
